import { useQuery } from '@tanstack/react-query';
import {
  validateBulkUnsubscribe,
  listUnsubscriptions,
  countUnsubscriptions,
  getUnsubscribedDomains,
  getUnsubscriptionStatus,
} from '../services/unsubscribe';
import { useUnsubscribeNextContext } from '../containers/UnsubscribeNext/context';

export const useListingUnsubscription = ({ search, page, limit }) => {
  return useQuery(
    ['unsubscriptions', { search, page, limit }],
    () => listUnsubscriptions({ search, page, limit }),
    {
      initialData: [],
    },
  );
};

export const useUnsubscriptionCount = ({ search }) => {
  return useQuery(
    ['unsubscriptionsCount', { search }],
    () => countUnsubscriptions({ search }),
    {
      initialData: 0,
    },
  );
};

export const useValidateBulkUnsubscribe = file => {
  return useQuery(
    ['validate-bulk-unsubscribe', { file }],
    () => {
      const formData = new FormData();
      formData.append('file', file);
      return validateBulkUnsubscribe(formData);
    },
    {
      staleTime: 0,
      cacheTime: 0,
      enabled: !!file,
      networkMode: 'always',
    },
  );
};

export const useListingUnsubscribedDomains = () => {
  return useQuery(
    ['unsubscribedDomain'],
    () => getUnsubscribedDomains().then(data => Object.values(data)),
    {
      initialData: [],
    },
  );
};

export const useGetUnsubscriptionStatus = token => {
  const { setPage } = useUnsubscribeNextContext();
  return useQuery(
    ['unsubscriptionStatus'],
    () => getUnsubscriptionStatus(token),
    {
      onError: () => {
        setPage('error');
      },
    },
  );
};
